"use client"

import PropTypes from "prop-types"
import { createContext, useEffect, useRef, useState } from "react"

export const ModalContext = createContext({})

/**
 * ModalProvider to integrate the Modal component into the app
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - The children of the ModalProvider
 * @returns {JSX.Element}
 */
export const ModalProvider = ({ children }) => {
  const modalNode = useRef(null)
  const [stateModalNode, setStateModalNode] = useState(null)

  useEffect(() => {
    setStateModalNode(modalNode.current)
  }, [])

  return (
    <ModalContext.Provider value={{ modalNode: stateModalNode }}>
      {children}
      <div ref={modalNode} className="Modal" />
    </ModalContext.Provider>
  )
}

ModalProvider.propTypes = {
  /** The children of the ModalProvider */
  children: PropTypes.node,
}
